import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
export const EnrolledSummarySection = ({ title, children, }) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: "sui-mb-4" },
            React.createElement(Typography, { variant: "h3", weight: "display" }, title)),
        React.createElement("div", { className: "sui-grid md:sui-grid-cols-9" }, children)));
};
